// extracted by mini-css-extract-plugin
module.exports = {"HomeWrapper":"Home_HomeWrapper__2s3og","heading":"Home_heading__3dC6-"};